import { render } from "./FinderCollis.vue?vue&type=template&id=4f5abf91"
import script from "./FinderCollis.vue?vue&type=script&lang=js"
export * from "./FinderCollis.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__